const ArrowDraw = require("../../util/ArrowDraw");
const colors = require("../../util/ColorUtil").getDiagramColors();

// The aspect ratio of the given plot height/width will be maintained and the plot will be centered as necessary
// ctx: context to draw upon
// x, y: top left coordinates
// w, h: width and height
// plotWidth: the width of the coordinate system in units
// plotheight: the height of the coordinate system in units
// points: array containing points on coordinate system expressed as [x, y]
// lines: array containing line segments expressed as pairs of point indices (from points array) ex:
//        [ [0, 2], [2, 4] ] would draw lines from the first to third point, and the third to fifth point
// tracedLines: same format as lines array, but will draw tracing arrows along the lines (arrow will be drawn from first point to second point)
// odds: array of point indices for "odd" points to be marked (odd points are points that have an odd number of lines that contain them)
module.exports = function(
	ctx,
	x,
	y,
	w,
	h,
	plotWidth,
	plotHeight,
	points,
	lines,
	tracedLines,
	odds
) {
	const marginInUnits = 0.2;
	let xMarginInUnits = marginInUnits;
	let yMarginInUnits = marginInUnits;
	const unitSizeByWidth = w / (plotWidth + marginInUnits * 2);
	const unitSizeByHeight = h / (plotHeight + marginInUnits * 2);
	const unitSize = Math.min(unitSizeByWidth, unitSizeByHeight);

	if (unitSize < unitSizeByWidth)
		xMarginInUnits =
			(w - unitSize * (plotWidth + 2 * marginInUnits)) / unitSize;
	if (unitSize < unitSizeByHeight)
		yMarginInUnits =
			(h - unitSize * (plotHeight + 2 * marginInUnits)) / unitSize;

	const getCoordsFromPlotPoint = function(plotPoint) {
		return [
			x + (xMarginInUnits + plotPoint[0]) * unitSize,
			y + (yMarginInUnits + (plotHeight - plotPoint[1])) * unitSize,
		];
	};

	// draw given lines
	ctx.save();
	ctx.strokeStyle = colors.gray;
	ctx.lineWidth = unitSize * 0.02;
	lines.forEach(l => {
		const pt1 = getCoordsFromPlotPoint(points[l[0]]);
		const pt2 = getCoordsFromPlotPoint(points[l[1]]);
		ctx
			.bp()
			.M(pt1)
			.L(pt2);
		ctx.stroke();
	});
	ctx.restore();

	// blur odds
	ctx.save();
	ctx.strokeStyle = colors.inputContrastFill;
	ctx.lineWidth = unitSize * 0.035;
	odds.forEach(o => {
		const coords = getCoordsFromPlotPoint(points[o]);
		ctx.shadowColor = colors.inputContrastFill;
		ctx.shadowOffsetX = 0;
		ctx.shadowOffsetY = 0;
		ctx.beginPath();
		ctx.setShadowBlur(unitSize * 0.16);
		ctx.arc(coords[0], coords[1], unitSize * 0.08, 0, 2 * Math.PI);
		for (let i = 0; i < 15; i++) {
			ctx.stroke();
		}
	});
	ctx.restore();

	// draw regular points
	points.forEach(p => {
		const pointCoords = getCoordsFromPlotPoint(p);
		ctx
			.bp()
			.arc(pointCoords[0], pointCoords[1], unitSize * 0.08, 0, 2 * Math.PI)
			.fill();
	});

	// draw endpoints of traced lines (separated so circle and blue can be drawn over point but under lines)
	ctx.save();
	ctx.lineWidth = unitSize * 0.04;
	ctx.fillStyle = colors.inputBlue;
	ctx.strokeStyle = colors.inputBlue;
	tracedLines.forEach(tl => {
		const pt1 = getCoordsFromPlotPoint(points[tl[0]]);
		const pt2 = getCoordsFromPlotPoint(points[tl[1]]);
		ctx
			.bp()
			.arc(pt1[0], pt1[1], unitSize * 0.08, 0, 2 * Math.PI)
			.fill();
		ctx
			.bp()
			.arc(pt2[0], pt2[1], unitSize * 0.08, 0, 2 * Math.PI)
			.fill();
	});
	ctx.restore();

	// circle odds
	ctx.save();
	ctx.strokeStyle = colors.inputContrastFill;
	ctx.lineWidth = unitSize * 0.035;
	odds.forEach(o => {
		const coords = getCoordsFromPlotPoint(points[o]);
		ctx
			.bp()
			.arc(coords[0], coords[1], unitSize * 0.08, 0, 2 * Math.PI)
			.stroke();
	});
	ctx.restore();

	// draw traced lines
	ctx.save();
	ctx.lineWidth = unitSize * 0.04;
	ctx.fillStyle = colors.inputBlue;
	ctx.strokeStyle = colors.inputBlue;
	tracedLines.forEach(tl => {
		const pt1 = getCoordsFromPlotPoint(points[tl[0]]);
		const pt2 = getCoordsFromPlotPoint(points[tl[1]]);
		// Shortening line manually because arrow util puts center of arrow at end of line
		const headLength = unitSize * 0.1;
		const headHeight = unitSize * 0.08;
		const start = pt1;
		let end = pt2;
		const dx = end[0] - start[0];
		const dy = end[1] - start[1];
		const totalLength = Math.sqrt(dx * dx + dy * dy);
		const scale = (totalLength - headLength * 1.1) / totalLength;
		end = [start[0] + scale * dx, start[1] + scale * dy];
		ArrowDraw.drawArrow(ctx, {
			x1: start[0],
			y1: start[1],
			x2: end[0],
			y2: end[1],
			headLength,
			headHeight,
		});
	});
	ctx.restore();
};
